/* eslint-disable max-len */
/**
 * Recording
 * 
 * @Author: Focci
 * @Date: 2023-08-07 10:17:41
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-07 10:17:41
 */

'use client'

import PropTypes from 'prop-types'
import useLazyComponent from '@hook/useLazyComponent'
import useTracking from '@hook/useTracking'
import useFetch from '@hook/useFetch'
import { formatLang } from '@lib/datetime'
import { isArray } from 'lodash-es'
import { useLocale, useTranslations } from 'next-intl'
import { useCallback, useMemo } from 'react'
import NeedLoginScoff from '../NeedLoginScoff'

export default function PropertyRecording({
  house,
  propertyId
}) {
  const locale = useLocale()
  const th = useTranslations('house')
  const { Wedget: RecordingBody, getWedget, ready } = useLazyComponent()
  const { pushTrackListingClick } = useTracking()

  const { data, isLoding } = useFetch(ready ? `property/histories/${propertyId}` : null)
  const lastUpdate = useMemo(
    () => (data?.[0]?.labelTime ? formatLang(data[0].labelTime, th('lastUpdatetime'), locale) : ''), 
    [data, th, locale]
  )

  const handleFolding = useCallback((expand) => {
    expand && pushTrackListingClick('property_history-more', house)
  }, [pushTrackListingClick, house])

  const handleEnter = useCallback(
    () => getWedget(() => import('./RecordingBody')), 
    [getWedget]
  )
  
  if(isArray(data) && data.length === 0) {
    return null
  }
  
  return (
    <NeedLoginScoff
      ready={ready && !!data}
      onEnter={handleEnter}
      title={th('propertyRecording')}
      moduleName={th('propertyRecording')}
      id="module-propertyRecording"
      needLoginProps={{ loading: isLoding && !!data }}
      meta={
        <div className="mt-2 font-medium">
          {lastUpdate}
        </div>
      }
    >
      {data && (
        <RecordingBody data={data} onFolding={handleFolding} />
      )}
    </NeedLoginScoff>
  )
}

PropertyRecording.propTypes = {
  propertyId: PropTypes.number,
}
